import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import PreLoginPage from '../../views/core/PreLoginPage';
import UserStorageUtil from '../../util/UserStorageUtil';
import lessonDefaultIcon from '../../images/lessons.png';
var imagePath = "/lesson/get_lesson_thumbnails?image=";


class LessonComponent extends PreLoginPage {
	
  constructor(props) {
  	super(props);

		this.loadLessonThumbnail = this.loadLessonThumbnail.bind(this);
		this.lockcontent=this.lockcontent.bind(this);
		// this.isFreeTrail = this.props.isFreeTrail || true;
	}

	componentDidMount(){
		// this.isFreeTrail = this.props.isFreeTrail || true;
		//console.log("isFreeTrail2",this.props.isFreeTrail,': ',this.props.isFrom);
	}
	
//----------------- get lesson thumbnail-----------------
  loadLessonThumbnail(lessonPath){    	
  	var backgroundImg = "";
  	
  	var _url = lessonPath.toLowerCase();
  	var lessonMapClass = "";
  	var lid = _url;
  	var thumb = "";
  	var lessonURL = "";
  	
  	if(lid.trim().length>0) {		
  		backgroundImg = (this.getUrlFor("CS_BASE_URL")+imagePath+lid+"&type=lessons");
  		//console.log(imagePath+lid+"&type=lessons");
  	}
  	else{		
  		backgroundImg = lessonDefaultIcon;
  	}
  	
  	return backgroundImg;
  }
  getListBGImage(_img) {		
		return "url('"+_img+"')";
	}
  //--------------------------------
  openLessonFromScorecard(){
		//console.log("this.props.PLPloggedIn=="+this.props.PLPloggedIn);
		if(this.props.isFreeTrail){
			return;
		}
	 if(this.props.PLPloggedIn == false || this.props.PLPloggedIn == "false"){
		 this.props.showNewLoginForm();
		 return;
	 }
	//console.log(this.props.lesson);
	var lessonidTracking = this.props.lesson.lessonid || this.props.lesson.lessonId;
	var lessonid = this.props.lesson.lessonUrl || this.props.lesson.lessonurl;
	var lessonname = this.props.lesson.lessonName || this.props.lesson.lessonname;
	var lurl = this.props.lesson.lessonUrl ||this.props.lesson.lessonurl;
	var dd = !isNaN(this.props.lesson.preferredDdId) ? this.props.lesson.preferredDdId : (!isNaN(this.props.lesson.lessondd) ? this.props.lesson.lessondd : 0);
	var lessonPref = this.props.lesson.lessontype;
	var testid = this.props.testId;
	var topicSubTopicMapId = this.props.topicSubTopicMapId;
	var accessId = this.props.accessId;
	var classId = this.props.classId;
	var snippetId = this.props.snippetId || "";
	var source = this.props.source || 0;
	//var _url = lesson_Url+"/lessonViewDD.action?lessonid="+lessonid+"&lessonname="+lessonname+"&url="+lurl+"&src=Revision&&dd="+dd;
	//var _url = "https://testrevision.heymath.com/lessonView.action?lessonid="+lessonid+"&lessonname="+lessonname+"&url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&src=plp&dd="+dd;
	var _url = "";

    let loginId = this.getUser().getLoginId();
	let userId = this.getUser().getUserId();
	console.log("loginId",loginId);
	console.log("userId",userId);
	  
	if(lessonPref === "mozart"){
		_url = "/mozartview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;
	}else{
		_url = "/lessonview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source+"&istraneditable=false&trankey="+userId;
	}
   
  if(dd > 0){
    _url += "&dd="+dd;
  }

  UserStorageUtil.storeSessionItem(lurl,lessonname);
	//console.log(_url);
	window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();
	}
	
	lockcontent(){
		if(this.props.isFreeTrail){
			return(
				<i className="material-icons md-40 playicon upgrdlock1">lock</i>
			)
		}else{
			return(
				<i className="material-icons md-40 playicon">play_circle_filled</i>
			)
		}
	}

  render() {	
		var classdisabled = "";	
					if(this.props.isFreeTrail){
						classdisabled = "disabled lockdisabledcont";
					}
    return (  
    			 
                <div className={"card clearfix"+classdisabled} onClick={this.openLessonFromScorecard.bind(this)}>
		    		  <div className="card-img-top subtopic text-center">   
		    		  	<img height="90" width="120" src={this.loadLessonThumbnail(this.props.lesson.lessonUrl || this.props.lesson.lessonurl)} />		    		  		 
		    		  	
		    		  	<div className="playContainer">
		    		  		{this.lockcontent()}</div>
		    		   </div>
		    		 
		               <div className="card-body">	
		    				<div className="card-title">{this.props.lesson.lessonName || this.props.lesson.lessonname}</div>
			      	  </div> 
	    		</div>
	    		
    );
  }
}

export default LessonComponent;



// WEBPACK FOOTER //
// ./src/views/scorecard/LessonComponent.js